import { makeVar } from "@apollo/client"

/** Updated from wrapPageElement so assistant context works outside the route tree. */
export const outfitterAssistantPathnameVar = makeVar<string>("/")
